import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import DocumentDetail from "@/pages/DocumentDetail";
import DocumentEdit from "@/pages/DocumentEdit";
import UploadPage from "@/pages/Upload";
import Approvals from "@/pages/Approvals";
import Expiring from "@/pages/Expiring";
import Categories from "@/pages/Categories";
import Departments from "@/pages/Departments";
import DepartmentWorkspace from "@/pages/DepartmentWorkspace";
import TableOfContents from "@/pages/TableOfContents";
import Users from "@/pages/Users";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-zinc-400 text-sm">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="documents" element={<Documents />} />
            <Route path="documents/:id" element={<DocumentDetail />} />
            <Route path="documents/:id/edit" element={<DocumentEdit />} />
            <Route path="upload" element={<UploadPage />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="expiring" element={<Expiring />} />
            <Route path="categories" element={<Categories />} />
            <Route path="departments" element={<Departments />} />
            <Route path="departments/:id" element={<DepartmentWorkspace />} />
            <Route path="toc" element={<TableOfContents />} />
            <Route path="users" element={<Users />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
